import { useQuery } from "@apollo/client";
import { MY_NOTIFICATIONS } from "../notification.queries";
import {
  MyNotificationsQuery,
  MyNotificationsQueryVariables,
} from "../../../__generated__/MyNotificationsQuery";

// Pas de subscription WebSocket sur ce module (§33) : on interroge périodiquement.
const POLL_INTERVAL = 60000;

export const useMyNotifications = (
  variables?: MyNotificationsQueryVariables,
  poll = true
) => {
  return useQuery<MyNotificationsQuery, MyNotificationsQueryVariables>(MY_NOTIFICATIONS, {
    variables,
    pollInterval: poll ? POLL_INTERVAL : 0,
    fetchPolicy: "cache-and-network",
  });
};
